<template>
 <Layout :ads='ads' :clientId='clientId' :showid='showid' :channels='channels' :setTitle='title' :apiOrigin="apiOrigin">
        <div>
            <div class="article">
                <!-- 列表 开始 -->
                <publicList :list="newsList" :clientId="clientId"></publicList>
                <a class="more" @click="more" v-show="meta.page_count>meta.current_page" href="javascript:;" id="pc-more">{{showMore}}</a>
                <a class="more" v-show="newsList.length==0||meta.page_count==meta.current_page" href="javascript:;" id="pc-more">没有更多了</a>
            </div>
            <!-- 列表 结束 -->
            <!-- 右侧列表开始 -->
            <div class="aside">
                <newsImgAside title="热门新闻" :list="reWenList" :clientId="clientId"></newsImgAside>
            </div>
        </div>
    </Layout>

</template>
<style lang="css">
    @import "~asset/news-pc/css/css.css";
    body {
        margin: 0 0px;
    }

    a {
        text-decoration: none;
    }
</style>
<script>
    import Layout from 'component/web/news-layout';
    import newsImgAside from 'component/web/news-aside/img-aside';
    import swiper from 'component/web/swiper/swiper';
    import publicList from 'component/web/news-list/public-list';
    import axios from 'asset/news-pc/js/axios.js';
    import api from 'asset/news-pc/js/api.js';
    export default {
        components: {
            Layout,
            newsImgAside,
            publicList,
        },
        data() {
            return {
                page: 2,
                showMore: '加载更多'
            };
        },
        mounted() {

/*             axios.get(api.news).then(data => {
                this.newsList = data.data.data.items;
                this.pageList = data.data.data.items;
            });
            axios.get(api.rewen).then(data => {
                this.reWenList = data.data.data.items;
            });
            axios.get(api.bianmin).then(data => {
                this.bianMinList = data.data.data.items;
            }); */
        },
        methods: {
            more() {
                this.showMore = '加载中';
                axios.get(`${api.news}?page=${this.page}&channel_id=${this.channelId}`).then(data => {
                    this.newsList = [...this.newsList, ...data.data.data.items];
                    this.meta = data.data.data._meta;
                    this.showMore = '加载更多';
                    this.page++;
                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// app/web/page/news-pc/list.vue